import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import * as Yup from "yup";
import { Translate } from "../../../../language";
import { UploadImage } from "../../../../components/Register/UploadFile";
import CreateWarehouseAccountView from "../../../containers/Inventory/Warehause/CreateWarehouseAccountView";
import { createWareHouse } from "../../../actions/wareHouseActions";
import { useDispatch } from "react-redux";



const validationSchema = Yup.object().shape({
  name: Yup.string().required("Es requerido"),
  email: Yup.string().required("Es requerido"),
  phone: Yup.string().required("Es requerido"),
  identificationNumber: Yup.string().required("Es requerido"),
  password: Yup.string().required("Es requerido"),
  passwordConfirm: Yup.string().required("Es requerido"),
  neighborhood: Yup.string().required("Es requerido"),
  businessAddress: Yup.string().required("Es requerido"),
  businessCountry: Yup.string().required("Es requerido"),
  businessDepartment: Yup.string().required("Es requerido"),
  businessCity: Yup.string().required("Es requerido"),
  picture: Yup.string().required("Es requerido"),
  identificationFile: Yup.string().required("Es requerido"),
  addressFile: Yup.string().required("Es requerido"),
  /* AdmWarehouse: Yup.string().required("El campo administrador es requerido"), */
});
export default function CreateWarehouseAccount() {
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      businessCountry: "",
      businessDepartment: "",
      businessCity: "",
      neighborhood: "",
      businessAddress: "",
      identificationType: "",
      identificationNumber: "",
      password: "",
      passwordConfirm: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const ubication = {
        businessCountry: values.businessCountry,
        businessDepartment: values.businessDepartment,
        businessCity: values.businessCity,
        neighborhood: values.neighborhood,
        businessAddress: values.businessAddress
      }



      //alert(JSON.stringify(values,null,4));
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('email', values.email);
      formData.append('phone', values.phone);

      formData.append('ubication', JSON.stringify(ubication));

      formData.append('identificationType', values.identificationType);
      formData.append('identificationNumber', values.identificationNumber);
      formData.append('password', values.password);
      formData.append('passwordConfirm', values.passwordConfirm);
      formData.append('picture', values.picture);
      formData.append('identificationFile', values.identificationFile);
      formData.append('addressFile', values.addressFile);


      dispatch(createWareHouse(formData))
    }


  })

  
  return (
    <CreateWarehouseAccountView formik={formik} />
  );
}
